import React, { cloneElement, useId } from 'react';
import { StyledFieldset, StyledLegend, StyledInner, StyledFormMessage } from './index.styles.js';
import {} from '../radio-button/index.js';
import {} from '../checkbox/index.js';
import {} from '../text-input/index.js';
import {} from '../select-field/index.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const FormGroup = ({ children, legend, invalid, disabled, variant = 'vertical', hint, className, margin, ...rest }) => {
    const isInvalid = invalid && !disabled;
    const ariaDescribedByProp = pickA11yProps(rest)['aria-describedby'];
    const modifiedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return cloneElement(child, {
                disabled: child.props.disabled ?? disabled,
                invalid: child.props.invalid ?? isInvalid
            });
        }
        return null;
    });
    const id = useId();
    const hintId = `${id}--hint`;
    const ariaDescribedBy = hint || ariaDescribedByProp
        ? [
            hint ? hintId : undefined,
            ariaDescribedByProp ? ariaDescribedByProp : undefined
        ]
            .join(' ')
            .trim()
        : undefined;
    return (React.createElement(StyledFieldset, { variant: variant, hasHintOrLegend: Boolean(hint || legend), className: className, disabled: disabled, ...pickA11yProps(rest), "aria-describedby": ariaDescribedBy, margin: margin, ...pickDataProps(rest) },
        legend && (React.createElement(StyledLegend, { disabled: disabled, invalid: isInvalid }, legend)),
        legend || hint ? (React.createElement(StyledInner, { variant: variant }, modifiedChildren)) : (modifiedChildren),
        hint && (React.createElement(StyledFormMessage, { id: hintId, variant: isInvalid ? 'error' : 'hint', text: hint, disabled: disabled }))));
};
//# sourceMappingURL=index.js.map